import React, { Dispatch, useContext } from 'react';
import { FilterItemGroup } from '../../../../components/filters/FilterItemGroup';
import { UseFormReturn } from 'react-hook-form';
import { GetTimeslots_workspace_timeslots } from '../../../../models/legacy-graphql';
import { Toggle } from '../../../../components/forms/Toggle';
import { CategoryFilterGroup } from '../../../../components/filters/CategoryFilterGroup';
import { SocialProfileFilterGroup } from '../../../../components/filters/SocialProfileFilterGroup';
import { ToggleAction } from '../../../../components/forms/Toggle/Toggle.controller';
import { TimeslotFilterAction, TimeslotFilterType } from '../../../../models/calendar';
import { CategoryType } from '../../../../components/filters/CategoryFilterGroup/CategoryFilterGroup.controller';
import { ProfileType } from '../../../../components/filters/SocialProfileFilterGroup/SocialProfileFilterGroup.controller';
import { FilterGroupsContainer } from '../../../../components/containers/FilterGroupsContainer';
import { ButtonMenuContext } from '../../../../components/actions/ButtonMenu/ButtonMenu.view';
import { Tooltip } from '../../../../components/actions/Tooltip';
import classes from './TimeslotFilterMenu.module.scss';
import { ActiveFilterGroup } from 'components/filters/ActiveFilterGroup';
import scssVars from '../../../../assets/scss/exportedVars.module.scss';

export type TimeslotFilterMenuViewProps = {
  formInstance: UseFormReturn;
  timeslots: GetTimeslots_workspace_timeslots[];
  profiles: ProfileType[];
  categories: CategoryType[];
  profilesFilteredTimeslots: GetTimeslots_workspace_timeslots[];
  categoriesFilteredTimeslots: GetTimeslots_workspace_timeslots[];
  loading: boolean;
  isMobile?: boolean;
  isDropdown?: boolean;
  filters: TimeslotFilterType;
  dispatchFilters: Dispatch<TimeslotFilterAction>;
};

export const TimeslotFilterMenuView = (props: TimeslotFilterMenuViewProps): JSX.Element => {
  const toggleAction: ToggleAction = (newVal, complete) => {
    props.dispatchFilters({ type: 'showOutOfSeason', payload: newVal });
    complete(true);
  };

  const showClearButton = !props.isMobile && (!!props.filters.profiles || !!props.filters.categories);
  const { openHandler } = useContext(ButtonMenuContext);

  return (
    <FilterGroupsContainer
      isDropdown={!!props.isDropdown}
      showClearButton={showClearButton}
      reset={() => props.dispatchFilters({ type: 'resetAll' })}
      close={() => {
        openHandler(false);
      }}>
      <ActiveFilterGroup
        category={props.categories.find(c => c.id === props.filters.categories)}
        profile={props.profiles.find(p => p.id === props.filters.profiles)}
        filters={props.filters}
        dispatchFilters={props.dispatchFilters}
      />
      <FilterItemGroup
        title={'Filter by Profile'}
        resetHandler={() =>
          props.isMobile
            ? props.dispatchFilters({ type: 'resetMobileProfiles' })
            : props.dispatchFilters({ type: 'resetProfiles' })
        }>
        <SocialProfileFilterGroup
          profiles={props.profiles}
          filters={props.filters}
          dispatchFilters={props.dispatchFilters}
          isMobile={props.isMobile}
          timeslots={props.categoriesFilteredTimeslots || []}
          loading={props.loading}
        />
      </FilterItemGroup>
      <FilterItemGroup
        title={'Filter by Category'}
        resetHandler={() => {
          props.dispatchFilters({ type: 'showOutOfSeason', payload: false });
          props.isMobile
            ? props.dispatchFilters({ type: 'resetMobileCategories' })
            : props.dispatchFilters({ type: 'resetCategories' });
        }}>
        <div className={'flex-container padding-bottom-small-24 padding-top-small-8'}>
          <Toggle
            formInstance={props.formInstance}
            name={'show-out-of-season'}
            rules={{}}
            action={toggleAction}
            label={'Show out-of-season'}
            disabled={props.loading}
            checked={props.filters.showOutOfSeason}
          />
          <Tooltip
            className={classes.ShowOutOfSeasonTooltip}
            type={'inlined'}
            position={'right'}
            pointer={true}
            autoZIndex={false}
            style={{ zIndex: scssVars['z-index-overmodal'] }}
            target={'#outOfSeason'}>
            <>
              <ul>
                <li>Turn this on to display timeslots for seasonal categories even when they’re out of season.</li>
                <li>Turn this off to declutter your Posting Plan and keep the focus on active content.</li>
              </ul>
            </>
          </Tooltip>
        </div>
        <CategoryFilterGroup
          categories={props.categories}
          filters={props.filters}
          dispatchFilters={props.dispatchFilters}
          isMobile={props.isMobile}
          showOutOfSeason={props.filters.showOutOfSeason}
          timeslots={props.profilesFilteredTimeslots || []}
          loading={props.loading}
        />
      </FilterItemGroup>
    </FilterGroupsContainer>
  );
};
